import { toggleSupportModal, toggleThanks, useCreateSupportTicketMutation } from "@/redux/slices/appStateSlice";
import { useAppDispatch, useAppSelector } from "@/redux/store";

export function useSupport() {
	const dispatch = useAppDispatch();
	const topAgency = useAppSelector(state => state.agency);
	const appSupport = useAppSelector(state => state.appState.support);
	const [createSupportTicket, { isLoading, isSuccess, isError }] = useCreateSupportTicketMutation();

	const triggerSupportOpen = () => {
		dispatch(
			toggleSupportModal({
				show: true,
				withAgencyId: +topAgency.agency_id,
			}),
		);
		dispatch(
			toggleThanks({
				showThanks: false,
			}),
		);
	};

	const triggerSupportClose = () => {
		dispatch(
			toggleSupportModal({
				show: false,
				withAgencyId: 0,
			}),
		);
	};

	const triggerThanksOpen = () => {
		dispatch(
			toggleThanks({
				showThanks: true,
			}),
		);
	};

	const triggerThanksClose = () => {
		dispatch(
			toggleThanks({
				showThanks: false,
			}),
		);
	};

	const openSupport = () => appSupport.show;

	const openThanks = () => appSupport.showThanks;

	const getAgencyId = () => +topAgency.agency_id;

	return {
		getAgencyId,
		openSupport,
		openThanks,
		triggerSupportOpen,
		triggerSupportClose,
		triggerThanksOpen,
		triggerThanksClose,
		supportApi: {
			createSupportTicket,
			isLoading,
			isSuccess,
			isError,
		},
	};
}
